<template>
    <label class="switch-label" @click="toggleValueFromLabel">{{label}}</label>
    <div v-if="textInsteadOfSwitch" class="cookie-settings-always-active">Always Active</div>
    <div v-else :class="appliedDivClasses" @click="toggleValue" @keyup.enter="toggleValue" role="checkbox" :aria-checked="modelValue" :aria-disabled="disabled" tabindex="0">
        <div class="switch">
        </div>
    </div>
</template>
<script>
    export default {
        name: "SwitchCheckbox",
        props: {
            'modelValue': {
                type: Boolean,
                default: true
            },
            'label': {
                type: String,
                default: ''
            },
            'disabled': {
                type: Boolean,
                default: false
            },
            'divClass': {
                type: String,
                default: 'toggle-switch'
            },
            'labelClass': {
                type: String,
                default: 'switch-label'
            },
            'allowLabelClickToToggleValue': {
                type: Boolean,
                default: true
            }
        },
        computed: {
            appliedDivClasses() {
                var retVal = this.divClass;
                retVal += this.modelValue === true ? ' on' : ' off';
                retVal += this.disabled === true ? ' disabled' : "";
                return retVal;
            },
            textInsteadOfSwitch() {
                var retVal = false;
                if (this.disabled === true && this.modelValue === true) {
                    retVal = true;
                }
                return retVal;
            }
        },
        methods: {
            toggleValue: function () {
                if (this.disabled !== true) {
                    this.$emit('update:modelValue', !this.modelValue); //Return the no option
                }
            },
            toggleValueFromLabel: function () {
                if (this.disabled !== true && this.allowLabelClickToToggleValue === true) {
                    this.$emit('input', !this.modelValue); //Return the no option
                }
            }
        }
    };
</script>